import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Filter, Download } from "react-feather";
import { Dropdown } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import ReportNavbar from "./AdminComp/ReportNavbar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import { Spinner } from 'react-bootstrap'; // Import the Spinner from react-bootstrap

const CustomerReport = () => {
  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  // Fetch user data from API on component mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllCustomerAdmin`);
        console.log("response", response);   
        if (response.data.message === "Users fetched successfully") {
          setUsers(response.data.data);
          setFilteredData(response.data.data);  // Initializing filteredData with all users
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      } finally {
        setLoading(false); // Set loading to false after the data is fetched
      }
    };

    fetchUsers();
  }, []);

  // Define columns for DataTable
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "30px",  
      style: { minWidth: "30px", maxWidth: "50px", textAlign: "start" }  
    },
    
    {
      name: "User Name",
      selector: (row) => `${row.first_name} ${row.middle_name ? row.middle_name + ' ' : ''}${row.last_name}`,
      sortable: true,
    },
    {
      name: "Contact Details",
      selector: (row) => row.user_email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    // {
    //   name: "Country",
    //   selector: (row) => row.country,
    //   sortable: true,
    // },
    {
      name: "Region",
      selector: (row) => row.region,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
   
  ];

  // Handle Excel Download
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "User Report");
    XLSX.writeFile(wb, "user_report.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <ReportNavbar />
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Customer Report</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search Users"
                onChange={(e) =>
                  setFilteredData(
                    users.filter((user) =>
                      `${user.first_name} ${user.middle_name || ""} ${user.last_name}`
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Status Filter
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(users)}>All</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <span className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} />&nbsp;Download
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              <div style={{ overflowX: "auto", maxHeight: "400px" }}>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    responsive
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerReport;
